/* global _ */
export default {
  data() {
    return {
      pageIndex: this.pageStart || 0,
    }
  },
  computed: {
    paginationAttrs() {
      return {
        total: this.pageCount,
        settings: this.$$s('pagination', {}),
        translations: this.$$t('pagination', {}),
      }
    },
    pageNumber() {
      return this.pageIndex + 1
    },
    pageCount() {
      return this.paginate ? Math.ceil(_.size(this.cards) / this.pageSize) : 1
    },
    hasPagination() {
      return this.paginate && this.pageCount > 1
    },
  },
  watch: {
    async pageIndex(value) {
      await this.$nextTick()
      if (this.scrollToTabMaxWidth) {
        const max = this.scrollToTabMaxWidth * 1
        if (max && this.appWidth <= max) {
          this.scrollTo('.re-profile-content > .re-profile-tab-content')
        }
      }
    }
  },
  methods: {
    goPage(pageNumber, isIndex = true) {
      const index = isIndex ? pageNumber : (pageNumber - 1)
      if (index >= 0 && index < this.pageCount) {
        this.pageIndex = index
      }
    },
    getPaginatedItems(cards) {
      if (!this.hasPagination) {
        return cards
      }
      const start = this.pageIndex * this.pageSize
      const end = start + this.pageSize
      const visible = _.slice(_.values(cards), start, end)
      return visible
    },
    nextPage() {
      this.goPage(this.pageIndex + 1)
    },
    prevPage() {
      this.goPage(this.pageIndex - 1)
    },
  }
}
